export default __webpack_public_path__ + "static/media/queen_of_spades2.c9de6912.png";